import ToolBar from "../../../components/ToolBar";
import "./CHMActivities.css";
import { Box, Tab, Tabs } from "@mui/material";
import { handleCHMPaginationDataSlice, handleUpdatePageSlice } from "../../../redux/slices/globalSlice";
import { handleCHMGisChartDataSlice, handleCHMInfoByIdDataSlice } from "../../../redux/slices/chmActivitySlice";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useState } from "react";
import CHMActivities from "./CHMActivities";
import CHMMasters from "../chmMasters/CHMMasters";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div className="py-3 tab-container">{children}</div>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const CHM = () => {
    const tabOptions = [
        { label: 'CHM Masters', tabId: 0 },
        { label: 'CHM Activities', tabId: 1 }
    ];

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const { storeCHMPaginationData } = useSelector((state: any) => state.global);


    const [value, setValue] = useState<number>(() => {
        const savedValue = localStorage.getItem("selectedCHMTab");
        return savedValue !== null ? parseInt(savedValue, 10) : 0;
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        localStorage.setItem("selectedCHMTab", newValue.toString());
        dispatch(handleUpdatePageSlice(false));
        dispatch(handleCHMInfoByIdDataSlice({}));
        dispatch(handleCHMGisChartDataSlice({}));
        dispatch(
            handleCHMPaginationDataSlice({
                ...storeCHMPaginationData,
                offset: 0,
                limit: 25,
                selectedLimit: 25,
            })
        );
    };

    return (
        <>
            <ToolBar
                title={'Crop Health Monitoring (CHM)'}
            />

            <div className="tab-section">
                <Tabs
                    TabIndicatorProps={{ style: { background: "rgba(92, 121, 170, 1)" } }}
                    value={value}
                    onChange={handleChange}
                >
                    {tabOptions?.map((tab: any, index: number) => {
                        return (<Tab
                            label={tab?.label}
                            style={{ color: "rgba(92, 121, 170, 1)", fontWeight: "600", textTransform: 'none', minWidth: '50%' }}
                            {...a11yProps(tab?.tabId)}
                            key={index}
                        />)
                    })}
                </Tabs>
            </div>

            <CustomTabPanel value={value} index={0}>
                <CHMMasters />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <CHMActivities />
            </CustomTabPanel>
        </>
    );
}

export default CHM;